import { getServiceUrl } from '../api';
import RequestService from '../httpRequest';

function request(config) {
  const { url, method, data, callback, failCallback, retry } = config;
  RequestService.sendRequest()
    .url(url)
    .method(method)
    .data(data)
    .success((res) => {
      RequestService.clearRequestTime();
      if (callback) callback(res);
    })
    .fail((res) => {
      if (failCallback) failCallback(res);
    })
    .networkFail(() => {
      if (retry) {
        RequestService.reAjaxFun(retry);
      } else if (failCallback) {
        failCallback({ data: { msg: '训练场请求超时或网络异常' } });
      }
    })
    .send();
}

function removeEmptyQueryValues(params) {
  return Object.entries(params || {}).reduce((result, [key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      result[key] = value;
    }
    return result;
  }, {});
}

export default {
  listTasks(params, callback, failCallback) {
    request({ url: `${getServiceUrl()}/agent-training/tasks`, method: 'GET', data: params, callback, failCallback });
  },
  createTask(data, callback, failCallback) {
    request({ url: `${getServiceUrl()}/agent-training/tasks`, method: 'POST', data, callback, failCallback });
  },
  getTask(id, callback, failCallback) {
    request({ url: `${getServiceUrl()}/agent-training/tasks/${id}`, method: 'GET', callback, failCallback });
  },
  runTask(id, callback, failCallback) {
    request({ url: `${getServiceUrl()}/agent-training/tasks/${id}/run`, method: 'POST', callback, failCallback });
  },
  cancelTask(id, callback, failCallback) {
    request({ url: `${getServiceUrl()}/agent-training/tasks/${id}/cancel`, method: 'POST', callback, failCallback });
  },
  deleteTask(id, callback, failCallback) {
    request({ url: `${getServiceUrl()}/agent-training/tasks/${id}`, method: 'DELETE', callback, failCallback });
  },
  listMessages(id, callback, failCallback) {
    request({ url: `${getServiceUrl()}/agent-training/tasks/${id}/messages`, method: 'GET', callback, failCallback });
  },
  listSuggestions(params, callback, failCallback) {
    request({ url: `${getServiceUrl()}/agent-training/growth/suggestions`, method: 'GET', data: params, callback, failCallback });
  },
  approveSuggestion(id, data, callback, failCallback) {
    request({ url: `${getServiceUrl()}/agent-training/growth/suggestions/${id}/approve`, method: 'POST', data, callback, failCallback });
  },
  rejectSuggestion(id, callback, failCallback) {
    request({ url: `${getServiceUrl()}/agent-training/growth/suggestions/${id}/reject`, method: 'POST', callback, failCallback });
  },
  listKnowledge(params, callback, failCallback) {
    request({
      url: `${getServiceUrl()}/agent-training/growth/knowledge`,
      method: 'GET',
      data: removeEmptyQueryValues(params),
      callback,
      failCallback
    });
  },
  enableKnowledge(id, callback, failCallback) {
    request({ url: `${getServiceUrl()}/agent-training/growth/knowledge/${id}/enable`, method: 'POST', callback, failCallback });
  },
  disableKnowledge(id, callback, failCallback) {
    request({ url: `${getServiceUrl()}/agent-training/growth/knowledge/${id}/disable`, method: 'POST', callback, failCallback });
  }
};
